const downloadFile = (base64File, chave, extensao) => {
  const link = document.createElement('a')
  link.href = base64File
  link.download = `${chave}.${extensao}`
  link.click()
}

const SetupDownload = (xml, obj, propriedade, extensao, chave, self, localizado) => {
  if (self[obj][propriedade] !== '/download') {
    downloadFile(self[obj][propriedade], chave, extensao)
    return
  }

  const xhrDownload = new XMLHttpRequest()
  xhrDownload.onload = () => {
    if (xhrDownload.status == 200 && localizado) {
      const json = JSON.parse(xhrDownload.responseText)
      self[obj][propriedade] = json
      downloadFile(self[obj][propriedade], chave, extensao)
      return
    }

    self[obj][propriedade] = '/download'
  }

  xhrDownload.open('POST', self.$apiUrl + 'PedidosVenda.svc/downloaddanfe')
  xhrDownload.setRequestHeader('Content-type', 'application/json')
  xhrDownload.withCredentials = true

  xhrDownload.send(
    JSON.stringify({
      chave: chave,
      xml: xml,
    })
  )
}

export default {
  SetupDownload
}
